import TypeIcon from "../../../assets/svg/type.svg";
import CategoryIcon from "../../../assets/svg/category.svg";
import DescriptionIcon from "../../../assets/svg/description.svg";
import PlatformIcon from "../../../assets/svg/platforms.svg";
import {platformIconsLight, platformIconsDark} from "./PlatformIcons";
import {useTheme} from "../../../hooks/useTheme";


export default function ProductCard({product, direction, animating, position}) {
  const {theme} = useTheme();
  const isDark = theme === "dark";

  const icons = isDark ? platformIconsDark : platformIconsLight;

  const animClass = animating
    ? ""
    : direction === "forward"
      ? "slide-enter"
      : "slide-enter-reverse";

  return (
    <div className={`slide-content ${position} ${animClass}`}>
      <div className="text-block">
        <h3 className="product-name">{product.name}</h3>

        <div className="meta-row">
          <div className="meta-item">
            <div className="meta-text">
              <div className="slide_icon_text">
                <img src={TypeIcon} alt="Type Icon" className="meta-icon"/>
                <span className="meta-label">Type:</span>
              </div>
              <span className="meta-value">{product.type}</span>
            </div>
          </div>

          <div className="meta-item">
            <div className="meta-text">
              <div className="slide_icon_text">
                <img src={CategoryIcon} alt="Type Icon" className="meta-icon"/>
                <span className="meta-label">Category:</span>
              </div>
              <span className="meta-value">{product.category}</span>
            </div>
          </div>
        </div>

        <div className="desc-row">
          <div className="desc-text">
            <div className="slide_icon_text">
              <img src={DescriptionIcon} alt="Type Icon" className="meta-icon"/>
              <span className="meta-label">Description:</span>
            </div>

            <p className="desc-body">{product.description}</p>
          </div>
        </div>

        <div className="platforms-row">
          <div className="meta-text">
            <div className="slide_icon_text">
              <img src={PlatformIcon} alt="Type Icon" className="meta-icon"/>
              <span className="meta-label">Platforms:</span>
            </div>

            <div className="platform-icons">
              {product.platforms.map((p, index) => {
                const Icon = icons[p];
                return <Icon className="platform-icon"
                             key={p[index]}/>;
              })}
            </div>
          </div>
        </div>
      </div>

      <div className="phones-block">
        <div className="phone-main">
          <img src={product.image} alt={`${product.name} screenshot`}/>
        </div>
        <div className="phone-rotated">
          <img src={product.imageRotated} alt={`${product.name} preview`}/>
        </div>
      </div>
    </div>
  );
}
